import React from 'react';
import '../../Pages/Registeration/Registeration.css';
import { Col, Container, Row } from 'react-bootstrap';
import LogoBg from '../../assets/images/png/LogoMain.png';
import OtpImg from '../../assets/images/png/otp-img.png';




const numOfFields = 5;

const useSSNFields = () => {
  const [ssnValues, setValue] = React.useState({
    ssn1: '',
    ssn2: '',
    ssn3: '',
    ssn4: ''
  });

  return {
    handleChange: (e) => {
      const { maxLength, value, name } = e.target;
      const [fieldName, fieldIndex] = name.split('-');

      // Check if they hit the max character length
      if (value.length >= maxLength) {
        // Check if it's not the last input field
        if (parseInt(fieldIndex, 10) < 4) {
          // Get the next input field
          const nextSibling = document.querySelector(
            `input[name=ssn-${parseInt(fieldIndex, 10) + 1}]`
          );

          // If found, focus the next field
          if (nextSibling !== null) {
            nextSibling.focus();
          }
        }
      }



      setValue({
        ...value,
        [`ssn${fieldIndex}`]: value
      });
    }
  };
};



const OtpOne = ({ resend, seconds, resendColor, secondsColor }) => {

  const { handleChange } = useSSNFields();



  return (


    <section className="otp-screen reg-bg-color">
      <div className="registration-app h-100-vh">
        <Container>
          <img className="pt-4 LogoImage" src={LogoBg} />
          <div className="row align-items-center">
            <Col md={6} className="md-order-2">
              {<img src={OtpImg} className="img-fluid d-md-none" alt="" />}
            </Col>
            <Col md={5}>
              <div className="content text-center thankyou pt-5">
                <h1 className="thankYou">
                  Confirm your <br className="d-none d-lg-block" /> phone number
                </h1>

                <p className=" sms-otp">
                  An SMS has been sent to the{' '}
                  <br className="d-none d-lg-block" /> following phone number:
                  030******44
                </p>
                <div className="opt_box input-cont">
                  <input
                  autoFocus
                    onChange={handleChange}
                    name="ssn-1"
                    maxLength={1}
                    className="opt_input"
                    type="text"
                    autoComplete="off"




                  />

                  <input
                    name="ssn-2"
                    onChange={handleChange}
                    style={{ marginLeft: '10px' }}
                    maxLength={1}
                    className="opt_input"
                    type="text"
                    autoComplete="off"
                  />

                  <input
                    name="ssn-3"
                    onChange={handleChange}
                    style={{ marginLeft: '10px' }}
                    maxLength={1}
                    className="opt_input"
                    type="text"
                    autoComplete="off"
                  />

                  <input
                    name="ssn-4"
                    onChange={handleChange}
                    style={{ marginLeft: '10px' }}
                    maxLength={1}
                    className="opt_input"
                    type="text"
                    autoComplete="off"
                  />
                </div>
                <div className="pt-4">
                  <p style={{ color: resendColor }}>{resend} </p>
                </div>
                <div className="pt-2">
                  <p className="fw-700" style={{ color: secondsColor }}>
                    {seconds}
                  </p>
                </div>
                <div className="py-5">
                  <button className="btn-group text-uppercase" type="submit">
                    Continue
                  </button>
                </div>
              </div>
            </Col>
          </div>
        </Container>
      </div>
    </section>
  );
};

export default OtpOne;
